<!-- Body Content-->
<div class="pt-3 md:px-4 px-2 pb-8" aria-label="sales-calendar-container">

  <h1 class="text-base md:text-lg text-900 flex align-items-center mb-3 line-height-1" aria-label="sales-calendar-title">{{'SCHEDULE.CALENDAR.SALES_CALENDAR' | translate}} 
    <!-- <i class="fa fa-question-circle font-light text-xl text-600 cursor-pointer ml-2" [pTooltip]="'SCHEDULE.CALENDAR.SALES_CALENDAR' | translate" tooltipStyleClass="text-xs"></i> -->
    <a class="inline-flex align-items-center py-1 px-2 border-round text-white text-xs ml-2 bg-purple-600" href="https://guides.unifiedfitnessplatform.ai/showcase/cluihi8sy07zj4l527so16g6n" target="_blank" aria-label="help-guide-link">
      <img width="14" src="/assets/img/interactive-icon.svg" alt="Icon" />
      <span class="ml-2 hidden md:inline-block">Help Guide for {{'SCHEDULE.CALENDAR.SALES_CALENDAR' | translate}} </span>
    </a>
  </h1>

  <!-- Row -->
  <div class="xl:flex" aria-label="calendar-layout">

    <!-- Sidebar -->
    <div class="xl:w-14rem xl:mr-3" aria-label="calendar-sidebar">
      <!-- Calendar -->
      <div class="mb-3 md:mb-2 hidden md:block show-sidebar-calendar" aria-label="sidebar-calendar">
        <p-datepicker [inline]="true" styleClass="w-full" (onSelect)="OnDateChange($event)" [(ngModel)]="currentDate" aria-label="date-picker"></p-datepicker>
      </div>
      <!-- Calendar -->

      <form [formGroup]="FiltersForm" class="relative p-3 md:p-0 mt-3 md:mt-0 z-5" aria-label="filters-form">
      <div class="absolute shadow-1 top-0 left-0 w-full h-full border-round surface-0 md:hidden"></div>

      <div class="relative z-1">
        
      <!-- Task Categories -->
      <h6 class="text-700 text-xs mb-2 block uppercase mt-3" aria-label="task-category-label">{{'SCHEDULE.CALENDAR.TASK_CATEGORY' | translate }}</h6>
      <task-category
        [multi]="true"
        [formGroup]="FiltersForm"
        [controlName]="SelectedTaskCategoryFormControl"
        styleClass="fitness-calendar-select w-full text-xs"
        [placeHolder]="'TASK_LIST.TASK_CATEGORY' | translate"
        aria-label="task-category-selector">
      </task-category>
      <!-- Task Categories -->

       <!-- Task Types -->
       <h6 class="text-700 text-xs mb-2 block uppercase mt-3" aria-label="task-type-label">{{'SCHEDULE.CALENDAR.TASK_TYPE' | translate }}</h6>
       <p-multiSelect [options]="taskTypes" placeholder="0 {{'SCHEDULE.CALENDAR.TASK_TYPE_SELECTED' | translate }}"
        optionLabel="name" styleClass=" fitness-calendar-select w-full text-xs" selectedItemsLabel="{0} {{'SCHEDULE.CALENDAR.TASK_TYPE_SELECTED' | translate }}"
        [resetFilterOnHide]="taskTypes.length > 10" formControlName="SelectedTaskType"
        (onChange)="SelectClassType($event)" [maxSelectedLabels]="0" [showHeader]="taskTypes.length > 5"
        aria-label="task-type-multi-select">
        <ng-template let-tasktype pTemplate="item">
          <div class="task-item flex align-items-center">
            <i [ngClass]="'mr-3 '+tasktype.icon"></i>
            <div class="text-sm">{{tasktype.name}}</div>
        </div>
       </ng-template>
      </p-multiSelect>
      <!-- Task Types -->

      <!-- Staff -->
      <h6 class="text-700 text-xs mb-2 block uppercase mt-3" aria-label="staff-label">{{'SCHEDULE.CALENDAR.STAFF' | translate }}</h6>
      <p-multiSelect [options]="getAccessedStaffList$ | async" placeholder="0 {{'SCHEDULE.CALENDAR.STAFF_SELECTED' | translate }}"
        optionLabel="name" styleClass="fitness-calendar-select w-full text-xs" [resetFilterOnHide]="(getAccessedStaffList$ | async)?.length > 10"
         formControlName="SelectedStaff"
        (onChange)="SelectTrainer($event)" selectedItemsLabel="{0} {{'SCHEDULE.CALENDAR.STAFF_SELECTED' | translate }}"
        [maxSelectedLabels]="0" [showHeader]="(getAccessedStaffList$ | async)?.length > 5"
        aria-label="staff-selector-multi-select">
        <ng-template let-trainer pTemplate="item">
          <div class="flex align-items-center" >
          <p-avatar *ngIf="trainer.ff_picture; else nopic" [image]="trainer.ff_picture" aria-label="trainer-avatar"></p-avatar>
          <ng-template #nopic>
            <p-avatar label="{{trainer.name | titlecase | shortName}}" aria-label="trainer-avatar"></p-avatar>
          </ng-template>
          <span class="ml-2 text-sm w-md:5rem overflow-hidden white-space-nowrap text-overflow-ellipsis" pTooltip="{{trainer.name}}" tooltipStyleClass="text-xs">{{trainer.name}}</span>
          </div>
       </ng-template>
      </p-multiSelect>
      <!-- Staff -->

    </div>

    </form>
    </div>
    <!-- Sidebar -->

    <!-- Calendar -->
    <div class="xl:w-10 mt-4 lg:mt-0" [ngClass]="isTrainerView ? 'xl:pr-5':''" aria-label="main-calendar">
      <div class="surface-0 shadow-2 fitness-calendar-wrap overflow-y-auto" [ngClass]="CalendarFullScreen ? 'fixed h-full w-full left-0 top-0 z-100 fitness-calendar-fullscreen pt-6' : 'relative border-round shadow' " aria-label="calendar-container">

        <!-- Calendar Loader -->
        <div class="absolute left-0 top-0 w-full h-full flex align-items-center justify-content-center z-5 transition-all transition-duration-400" 
             [ngClass]="{'opacity-100 visible pointer-events-auto': (loading | async) === true, 'opacity-0 invisible pointer-events-none': (loading | async) === false}" 
             style="background: rgba(14, 14, 14, 0.3)" aria-label="calendar-loader">
          <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="2" fill="var(--surface-ground)" animationDuration=".5s" aria-label="loading-spinner"></p-progressSpinner>
        </div>
        <!-- Calendar Loader -->

        <div class="fitness-calendar" [ngClass]="CalendarFullScreen ? 'h-full' : '' " aria-label="calendar-view">
          <ejs-schedule #scheduleObj
                        width="100%"
                        height="100%"
                        cssClass="md-custom-header"
                        [selectedDate]="currentDate"
                        [currentView]="currentView"
                        [group]="group"
                        [eventSettings]="eventSettings"
                        (created)="onScheduleCreated($event)"
                        (eventClick)="onEventClick($event)"
                        (cellDoubleClick)="onCellDoubleClick($event)"
                        (cellClick)="onCellClick($event)"
                        (actionBegin)="onActionBegin($event)"
                        (actionComplete)="onActionComplete($event)"
                        (eventRendered)="onEventRendered($event)"
                        aria-label="event-calendar">

            <e-resources>
               <!-- Define resources based on trainer view -->
               <e-resource *ngIf="isTrainerView"
                  field='ResourceId'
                  title='Trainer'
                  name='Trainers'
                  [dataSource]='trainerResources'
                  textField='name'
                  idField='id'
                  colorField='color'
                  [allowMultiple]='true'>
               </e-resource>
            </e-resources>

            <!-- Resource Header Template -->
            <ng-template #resourceHeaderTemplate let-data>
              <div class="md-resource-details-cont flex align-items-center" [attr.aria-label]="'resource-details-' + data.resourceData?.name">
                <!-- Use this when Image not Present -->
                <div *ngIf="isTrainerView">
                  <p-avatar *ngIf="data.resourceData?.img; else noContactPic1" [image]="data.resourceData?.img" class="mr-2" [attr.aria-label]="'resource-avatar-' + data.resourceData?.name"></p-avatar>
                  <ng-template #noContactPic1>
                    <p-avatar styleClass="text-sm w-2rem h-2rem mr-2"  label="{{data.resourceData?.name | titlecase | shortName}}" [attr.aria-label]="'resource-avatar-' + data.resourceData?.name"></p-avatar>
                  </ng-template>
                </div>
                <div class="md-resource-details-name -mt-1 text-xs">{{data.resourceData?.name }}</div>
              </div>
            </ng-template>

            <e-views>
                <!-- Use all standard views with their proper configuration -->
                <e-view option="Day" [timeScale]="timeScaleOption"></e-view>
                <e-view option="Week" [timeScale]="timeScaleOption"></e-view>
                <e-view option="WorkWeek" [timeScale]="timeScaleOption"></e-view>
                <e-view option="Month" [showWeekend]="true" [showWeekNumber]="true" [maxEventsPerRow]="1"></e-view>
                <e-view option="Agenda" [allowVirtualScrolling]="true"></e-view>
                <e-view option="TimelineDay" [timeScale]="timeScaleOption" displayName="Trainer View" [resourceHeaderTemplate]="resourceHeaderTemplate" [group]="group"></e-view>
            </e-views>

              <!-- Agenda Template -->
              <ng-template #agendaTemplate let-data>
                <div class="md-full-event" [attr.aria-label]="'agenda-day-' + data.date">
                   <div *ngFor="let event of data.events">
                     <div class="p-2 line-height-2 text-900 overflow-hidden flex align-items-center justify-content-between cursor-pointer"
                          (click)="openTaskPopup(event)"
                          [ngClass]="event.CssClass" [attr.aria-label]="'agenda-event-' + event.Guid">
                           <div class="flex align-items-center" *ngIf="event.OriginalData" [ngClass]="isCompleted(event.OriginalData) ? 'line-through':''" aria-label="task-info">
                            <i [class]="getTaskTypeIcon(event)"></i>
                            <span>
                              {{'CLIENT_TASK.TOUR_SCHDEULD_WITH' | translate : { type: event.OriginalData.type, name: event.OriginalData.client_info?.full_name } }}
                            </span>
                          </div>
                          <div class="text-xxs" *ngIf="event.OriginalData">{{ event.StartTime | date: 'shortTime'}}</div>
                     </div>
                    <hr class="border-300 border-top-1 border-bottom-none border-left-none border-right-none m-0">
                   </div>
                 </div>
                 <hr class="border-white border-top-1 border-bottom-none border-left-none border-right-none my-0">
             </ng-template>

          </ejs-schedule>
        </div>

        <!-- Calendar Footer -->
        <div class="border-300 left-0 p-2 md:px-3 flex align-items-center justify-content-between" [ngClass]="CalendarFullScreen ? 'absolute w-full z-4 surface-0 top-0 border-bottom-1' : 'bottom-0 border-top-1' " aria-label="calendar-footer">
          <div class="flex align-items-center text-sm">
            <!-- Print button -->
            <button pButton pRipple type="button" (click)="printCalendar()" icon="fa fa-print" label="{{'SCHEDULE.CALENDAR.PRINT_CALENDAR' | translate }}" class="p-button-text text-xs md:text-sm text-900 hover:text-primary mr-2" aria-label="print-calendar-button"></button>
            <!-- Social share links (can be removed if not needed) -->
            <ul class="list-none m-0 p-0 flex align-items-center" aria-label="social-links">
              <li class="mr-3"><a href="#" target="_blank" class="fab fa-facebook text-blue-700" aria-label="facebook-share" data-testid="facebook-share"></a></li>
              <li class="mr-3"><a href="#" target="_blank" class="fab fa-twitter text-cyan-500" aria-label="twitter-share" data-testid="twitter-share"></a></li>
              <li class="mr-3"><a href="#" target="_blank" class="fab fa-instagram text-bluegray-600" aria-label="instagram-share" data-testid="instagram-share"></a></li>
              <li class="mr-3"><a href="#" target="_blank" class="fab fa-whatsapp text-green-500" aria-label="whatsapp-share" data-testid="whatsapp-share"></a></li>
            </ul>
          </div>
          <div (click)="toggleFullScreen()" [ngClass]="CalendarFullScreen ? 'fa-minimize' : 'fa-maximize' " class="fa cursor-pointer text-primary" data-testid="toggle-fullscreen-button">
          </div>
        </div>
        <!-- Calendar Footer -->
      </div>
    </div>
    <!-- Calendar -->

  </div>
  <!-- Row -->

</div>
<!-- Body Content-->

<!-- Dialogs -->
<app-call-outcome *ngIf="showCallOutcomePopup" [visible]="showCallOutcomePopup" [data]="outcomeDetail" (hideOutCome)="HideOutComePopup($event)" (modified)="reloadEvents($event)" (showClientProfile)="GoToClientDetails($event)" aria-label="call-outcome-dialog">
</app-call-outcome>

<app-tour-outcome *ngIf="showMeetingOutcomePopup" [visible]="showMeetingOutcomePopup" [tourOutComeData]="outcomeDetail" (hideOutCome)="HideOutComePopup($event)" (modified)="reloadEvents($event)" (showClientProfile)="GoToClientDetails($event)" aria-label="tour-outcome-dialog">
</app-tour-outcome>

<task-create
  *ngIf="showTaskCreate"
  [visible]="showTaskCreate"
  [cltIds]="[activeClientId]"
  [oppIds]="[]"
  (createdTask)="taskCreated($event)"
  (hide)="HideTaskCreate($event)"
  aria-label="task-create-dialog">
</task-create>

<client-info-sidebar *ngIf="showClientSidebar" [showClientSidebar]="showClientSidebar" [activeClientId]="activeClientId" (closeSidebar)="closeSidebar($event)" aria-label="client-info-sidebar"> </client-info-sidebar>
<!-- Dialogs -->
